<!-- 🔹 Print & Close Buttons (outside loop) -->
<div class="noPrint" style="margin-bottom: 20px; text-align: right;">
  <button class="btn btn-primary"
          mat-raised-button
          color="primary"
          printSectionId="print-all"
          ngxPrint
          [useExistingCss]="true">
    Print 
  </button>
  <button mat-dialog-close class="btn">Close</button>
</div>

<!-- 🔹 Wrapper for ALL printable content -->
<div id="print-all" class="print-container">
  <div *ngFor="let note of creditNoteList; let i = index" class="print-section-wrapper">
    <div class="container print-border">

      <!-- Header -->
      <div class="row">
        <div class="col-2 image">
          <img style="margin-top: 6%" width="85%" src="../../../assets/img/brand/red.png" />
        </div>
        <div class="col-8" style="padding-top: 30px; text-align: center; padding-bottom: 10px">
          <span style="font-size: 30px;" class="ft-wt-500">हिंदुस्थान प्रकाशन संस्था</span>
          <span style="font-size: 12px; margin-left: 5px">(Reg.No.-BOM-3/1961(GBDSD))</span>
          <hr />
          <div class="row" style="text-align: left">
            <div class="col-5" style="padding-top: 10px">
              <span style="font-size: 12px"><b style="font-size: 14px">प्रशासकीय कार्यालय :</b>
                116-119, पहिला मजला, शिल्पीन सेंटर, वडाला मुंबई - 400031<br /></span>
              <span style="font-size: 12px"><b style="font-size: 14px">दूरध्वनी:</b> 9967570531</span>
            </div>
            <div class="col-5" style="border-left: 2px solid; padding-top: 10px">
              <span style="font-size: 12px"><b style="font-size: 14px">मुख्य कार्यालय :</b>
                5/12, कामत औद्योगिक वसाहत, प्रभादेवी, मुंबई 400025.<br /></span>
              <span style="font-size: 12px"><b style="font-size: 14px">दूरध्वनी:</b> 24221440</span>
            </div>
          </div>
        </div>
        <div class="col-2" style="border-left: 2px solid; text-align: center; display: flex; align-items: center;">
          <span style="font-size: 18px">क्रेडिट नोट पावती</span>
        </div>
      </div>

      <!-- Seller Info -->
      <div class="row" style="border-top: 2px solid; text-align: center;">
        <div class="col-5" style="padding-top: 20px; text-align: left">
          <b style="font-size: 14px">Issue Seller Name:</b>
          <span style="font-size: 14px"><b>{{ note.issue_seller_name }}</b></span><br />
          <b style="font-size: 14px">Address:</b> {{ note.address || '-' }}<br />
          <b style="font-size: 14px">Mobile No:</b> {{ note.mobile_no || '-' }}
        </div>

        <div class="col-7" style="border-left: 3px solid">
          <div class="row" style="border-bottom: 2px solid; padding-top: 20px; padding-bottom: 10px;">
            <div class="col-6" style="text-align: left">
              <b style="font-size: 14px">क्रेडिट नोट क्रं.:</b>
              {{ note.credit_voc_no }}
            </div>
            <div class="col-6" style="text-align: left">
              <b style="font-size: 14px">दिनांक:</b>
              {{ note.credit_note_date | date: 'dd-MM-yyyy' }}
            </div>
          </div>

          <div class="row" style="padding-top: 10px">
            <div class="col-12" style="text-align: left">
              <b style="font-size: 14px">यांच्याकडुन रुपये:</b>
              {{ note.creadit_note_amt }} /-
            </div>
          </div>

          <div class="row" style="padding-top: 5px">
            <div class="col-6"></div>
            <div class="col-6" style="text-align: left">
              <b style="font-size: 14px">दिनांक:</b>
              {{ note.creation_date | date: 'dd-MM-yyyy' }}
            </div>
          </div>

          <div class="row" style="padding: 5px 0;">
            <div class="col-12" style="text-align: left">
              <b style="font-size: 14px">क्रेडिट नोट रक्कम रु.:</b>
              {{ note.creadit_note_amt }} /-
            </div>
          </div>

          <div class="row" style="padding-bottom: 10px">
            <div class="col-12" style="text-align: left">
              <b style="font-size: 14px">अक्षरी रक्कम:</b>
              {{ note.totalInWords || '-' }}
            </div>
          </div>
        </div>
      </div>

      <!-- Invoice Table -->
      <div class="row" style="border-top: 2px solid; padding-top: 20px;">
        <div class="col-12" style="text-align: left">
          <b style="font-size: 14px">Invoice No:</b> {{ note.invoice_no }}
        </div>
      </div>

      <div class="row">
        <table style="width: 95%; margin: 10px auto; border-collapse: collapse; border: 1px solid black;">
          <thead style="font-weight: bold;">
            <tr style="background-color:#f2f2f2;">
              <th style="border: 1px solid black; padding: 4px;">Bill No</th>
              <th style="border: 1px solid black; padding: 4px;">Date</th>
              <th style="border: 1px solid black; padding: 4px;">Invoice Amount</th>
              <th style="border: 1px solid black; padding: 4px;">Remaining Amount</th>
              <th style="border: 1px solid black; padding: 4px;">Credit Note Amount</th>
              <th style="border: 1px solid black; padding: 4px;">Unpaid Amount</th>
              <th style="border: 1px solid black; padding: 4px;">Remark</th>
            </tr>
          </thead>
          <tbody style="font-size: 14px;">
            <tr>
              <td style="border: 1px solid black; padding: 4px;">{{ note.invoice_no }}</td>
              <td style="border: 1px solid black; padding: 4px;">{{ note.invoice_date | date: 'dd-MM-yyyy' }}</td>
              <td style="border: 1px solid black; padding: 4px;">{{ note.invoice_amt }}</td>
              <td style="border: 1px solid black; padding: 4px;">{{ note.previous_remaining_amount }}</td>
              <td style="border: 1px solid black; padding: 4px;">{{ note.creadit_note_amt }}</td>
              <td style="border: 1px solid black; padding: 4px;">{{ note.unpaid_amount }}</td>
              <td style="border: 1px solid black; padding: 4px;">{{ note.remark }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Footer -->
      <div class="row" style="margin-top: 40px; padding-bottom: 10px">
        <div class="col-6">
          <span style="font-weight: bold; font-size: 12px">(धनादेश वटल्यावरच पावती अधिकृत होईल)</span>
        </div>
        <div class="col-6" style="text-align: right; font-weight: bold; font-size: 14px">
          व्यवस्थापक / लेखापाल
        </div>
      </div>
    </div>
  </div>
</div>
